(ns common.schema.entities.account.core
  (:require [clojure.string :as string]
            [common.schema.entities.account.permissions :as permissions]
            [common.schema.entities.account.schema :as schema]
            [common.util :as cu]))

(def entity-type-definition
  {:entity-type                  :entity.type/account
   :schema                       schema/schema
   :name                         {:en "User account"}
   :plural                       {:en "User accounts"}
   :icon                         :fa-eye-slash

   ;; FE+BE can build name from these without custom code
   :display-name-fn              (fn [{:keys [entity]}]
                                   (->> [(:account/first-name entity)
                                         (:account/last-name entity)]
                                        (remove cu/blank-value?)
                                        (string/join " ")))
   :display-name/depends-on      [:account/first-name :account/last-name]

   :search                       {:list/default-columns [:account/first-name
                                                         :account/last-name
                                                         :account/email]
                                  :list/default-sort    [:account/last-name :desc]
                                  :quick-filters        [:account/email]}

   :reporting                    {}

   :permissions                  {:creatable?   true
                                  :disableable? false}

   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
